<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><span class="txit">Acknowledgement</span></h2>
<p class="noindent">For the immense help he’s given me — medical, psychiatric and literary — not only on this book but on <span class="txit">Spider</span> as well — I’d like to express my love and gratitude to my father, Dr Patrick McGrath.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?9a867aee